<template>
  <modal
    :title="setModel==null?'Add Customer Contact':'Update Customer Contact'"
    @close="$emit('close')"
  >
    <template #content>
      <Form
        method="dialog"
        v-slot="{ errors }"
        class="floating-labels p-1rem"
        ref="form"
      >
            <formGroup
              :title="'Name'"
              v-model="model.Name"
              :errors="errors"
              :rules="{ required: true }"
              @keydown.enter="save"
            ></formGroup>
            <formGroup
              :title="'Email'"
              v-model="model.Email"
              :errors="errors"
              :rules="{ email: true }"
              @keydown.enter="save"
            ></formGroup>
            <formGroup
              :title="'Phone'"
              :maska="'0### ### ####'"
              v-model="model.Phone"
              :errors="errors"
              :rules="{ min: 13 }"
              @keydown.enter="save"
            ></formGroup>
            <formGroup
              :title="'Position'"
              v-model="model.Position"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
            <formGroup
              :title="'Note'"
              as="textarea"
              v-model="model.Note"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
      </Form>
    </template>
    <template #foot>
      <Btn
        class="btn-success btn-md"
        @click="save"
        :disabled="process"
        :process="process"
        >{{setModel==null?'Add Customer Contact':'Update Customer Contact'}}</Btn
      >
    </template>
  </modal>
</template>

<script>
export default {
  props: {
    setModel: Object,
    customerId: Number,
  },
  data() {
    return {
      addSoftwareOpen: false,
      model: {
        Id:null,
        CustomerId:this.customerId,
        Name:"",
        Email:"",
        Phone:"",
        Position:"",
        Note:""
      },
      process: false,
    };
  },
  created() {
    if(this.setModel!=null){
      this.model=this.setModel;
    }
  },
  methods: {
    save() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.process = true;
          this.$appAxiosAdmin
            .put(`CustomerContacts`, {
              ...this.model
            })
            .then((response) => {
              this.process = false;
              this.$swal({
                icon: "success",
                title: "Success",
                text: "The customer contact has been successfully "+(this.setModel!=null?'updated':'added')+".",
                timer: 2000,
                confirmButtonText: "Okey",
              });
              this.$emit((this.setModel!=null?'update':'add'), response.data);
              this.$emit("close");
            })
            .catch((err) => {
              this.process = false;
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.birthDate {
  position: relative;
}
.birthDate > span {
  position: absolute;
  right: 50px;
  top: 50%;
  line-height: 0;
  font-weight: 400;
}
.colapse .card-header /deep/ .myCheckBox {
  margin-bottom: 0;
}
.colapse .card-header {
  padding: 9px 10px;
}
</style>
